import {
  CurrencyDisplay,
  CurrencyFormat,
  DEFAULT_CURRENCY_DISPLAY,
  DEFAULT_CURRENCY_FORMAT,
} from '@domain/currency-preferences';

export const numberFormatCache = new Map<string, Intl.NumberFormat>();

/** Mutable singleton written by `setCurrencyPreferences`, read by every formatter. */
export const currencyPreferences: { format: CurrencyFormat; display: CurrencyDisplay; lang: string } = {
  format: DEFAULT_CURRENCY_FORMAT,
  display: DEFAULT_CURRENCY_DISPLAY,
  lang: 'en',
};
